import classNames from "classnames/bind";
import { ErrorMessage } from "formik";
import { FC, ReactNode } from "react";
import { Paragraph } from "@datagame/ui";

import styles from "./FieldWrapper.module.scss";

const cx = classNames.bind(styles);

type FieldWrapperProps = {
  label: ReactNode;
  children: ReactNode;
  className?: string;
  name: string;
  isErrorWrapperIncluded?: boolean;
  errorWrapperClassName?: string;
  tip?: string;
  tipClassName?: string;
  withoutFormik?: boolean;
};

export const FieldWrapper: FC<FieldWrapperProps> = ({
  children,
  label,
  name,
  errorWrapperClassName,
  className,
  withoutFormik = false,
  tip,
  tipClassName,
}) => {
  const errorWrapperClass = cx("errorWrapper", errorWrapperClassName);
  const tipClass = cx("tip", tipClassName);
  const wrapperClass = cx("wrapper", className);

  const errorComponent = withoutFormik ? null : <ErrorMessage name={name} />;

  return (
    <div className={wrapperClass}>
      <div className={styles.labelWrapper}>
        <label htmlFor={name} className={styles.label}>
          {label}
        </label>
      </div>
      <div className={styles.inputWrapper}>{children}</div>
      <div className={errorWrapperClass}>{name && errorComponent}</div>
      {tip && (
        <Paragraph size="small" className={tipClass}>
          {tip}
        </Paragraph>
      )}
    </div>
  );
};
